import { Component } from '@angular/core';

@Component({
  selector: 'app-mail-manager',
  templateUrl: './mail-manager.component.html',
  styleUrls: ['./mail-manager.component.scss']
})
export class MailManagerComponent {

}
